
import { Component, Vue } from 'vue-property-decorator';
import Item from './components/item.vue';
import BlackItem from './components/black-item.vue';
import ValidateDialog from './components/validate-dialog.vue';
import { getNoteConfig, getNoteRulers, postNoteConfig, postNoteRulers } from '@/api/note-system';
import { ElForm } from 'element-ui/types/form';
import { iNoteConfig } from '@/interface/note-system';
import { toast } from '@/utils/common';
@Component({
  components: { Item, BlackItem, ValidateDialog },
})
export default class extends Vue {
  isLoading = false;
  modelSwitch: any = {
    risk_switch: true,
    singlePhones: [
      { name: '单手机号：', value: null, hours: 1 },
      { name: '', value: null, hours: 24 },
    ],
    singIps: [
      { name: '单 IP:', value: null, hours: 1 },
      { name: '', value: null, hours: 24 },
    ],
  };

  phoneList: any = [];
  ipList: any = [];

  ipType: string = 'ip';
  phoneType: string = 'phone'; //手机号段
  addType: string = '';
  model: any = {
    selectType: 0,
    selectinfo: {},
  };

  isShowDialog: boolean = false;
  errMsg: string = '';
  getValidator() {
    this.errMsg = '';
    let isPass = true;
    this.modelSwitch.singlePhones.forEach((item: any) => {
      console.log(typeof item.value, '2323');

      if (item.value != '' && !(item.value > 0)) {
        this.errMsg += '单手机号&nbsp' + item.hours + '&nbsp小时内&nbsp不超过发送的短信条数不能为空;&nbsp;&nbsp;&nbsp;  ';
        isPass = false;
      }
    });
    if (this.errMsg != '') {
      this.errMsg += '<br/>';
    }
    this.modelSwitch.singIps.forEach((item: any) => {
      if (item.value != '' && !(item.value > 0)) {
        this.errMsg += '单IP&nbsp' + item.hours + '&nbsp小时内&nbsp不超过发送的短信条数不能为空;&nbsp;&nbsp;&nbsp; ';
        isPass = false;
      }
    });
    return isPass;
  }

  deleteBlackItem(index: number, type: string) {
    //手机黑名单
    if (type == this.phoneType) {
      this.phoneList.splice(index, 1);
    } else {
      this.ipList.splice(index, 1);
    }
  }

  closeValidateDialog() {
    this.isShowDialog = false;
  }
  //修改/新增验证
  editInfo() {}
  addBalckInfo(type: string) {
    //手机黑名单
    this.isShowDialog = true;
    this.addType = type;
  }
  async submitForm() {
    try {
      this.isLoading = true;
      if (this.getValidator()) {
        //开始操作
        const { risk_switch, singlePhones, singIps } = this.modelSwitch;
        const data: iNoteConfig = {
          risk_switch: risk_switch,
          phone_in_01h_limit: parseInt(singlePhones[0].value),
          phone_in_24h_limit: parseInt(singlePhones[1].value),
          ip_in_01h_limit: parseInt(singIps[0].value),
          ip_in_24h_limit: parseInt(singIps[1].value),
        };
        const res = await postNoteConfig(data);
        if (res.code == 0) {
          toast('操作成功！');
          this.getNoteConfig();
        } else {
          toast(res.msg, 'error');
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  }
  async handlerRulers(kind: string) {
    const rulers = kind == 'phone' ? this.phoneList : this.ipList;
    const data = { kind, rulers };
    try {
      this.isLoading = true;
      const res = await postNoteRulers(data);
      if (res.code == 0) {
        toast('操作成功！');
        this.getNoteRulers(kind);
      } else {
        toast(res.msg, 'error');
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  }
  //验证码设置
  async getNoteConfig() {
    const res = await getNoteConfig();
    const { risk_switch, phone_in_01h_limit, phone_in_24h_limit, ip_in_01h_limit, ip_in_24h_limit } = res.data;
    this.modelSwitch.risk_switch = risk_switch;
    this.modelSwitch.singlePhones[0].value = phone_in_01h_limit;
    this.modelSwitch.singlePhones[1].value = phone_in_24h_limit;
    this.modelSwitch.singIps[0].value = ip_in_01h_limit;
    this.modelSwitch.singIps[1].value = ip_in_24h_limit;
  }
  //黑名单设置
  async getNoteRulers(kind: string) {
    const res = await getNoteRulers(kind);
    // const resPhone = await getNoteRulers('phone');
    if (kind == 'phone') {
      this.phoneList = res.data;
    } else {
      this.ipList = res.data;
    }
  }
  handleAddBlack(value: string) {
    if (this.addType == 'phone') {
      this.phoneList.push(value);
    } else {
      this.ipList.push(value);
    }
    this.isShowDialog = false;
  }

  mounted() {
    this.getNoteConfig();
    this.getNoteRulers('phone');
    this.getNoteRulers('ip');
  }
}
